import { color } from '../../utils/styles'
import styled from 'styled-components'

export const ErrorMessage = styled.p`
  color: ${color.red};
  margin: 0;
`
